import { SectionHeaderWithAccent } from '@/components/display/SectionHeaderWithAccent/SectionHeaderWithAccent';

export function AIOnboardingModalHeader() {
  return (
    <SectionHeaderWithAccent
      containerProps={{
        pt: 1.5,
        pb: 1.5,
        pl: 2,
        pr: 2,
      }}
      header={{
        heading: 'Review AI suggestions',
      }}
    />
  );
}
